import axios from 'axios';

export async function CallCepInfo(cep){    
    var result = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);    
    return result.data;    
}


